import React from 'react';
import PropTypes from 'prop-types';

const Carousel = (props) => {
  const { children } = props;
  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'space-evenly',
        width: 100,
        margin: '16px auto 0'
      }}
    >
      {children}
    </div>
  );
};

Carousel.propTypes = {
  children: PropTypes.node.isRequired
};

export default Carousel;
